"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialTooltipState = void 0;
const getInitialTooltipState = () => ({
    pinned: false,
    selected: [],
});
exports.getInitialTooltipState = getInitialTooltipState;
//# sourceMappingURL=get_initial_tooltip_state.js.map